module.exports = __webpack_public_path__ + "images/category_lp/camera/Nikon-D4_ed7bbd1d45856ba214f74f285ae53869.png";